
(function(jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /************************************************/
    /* Admissions Inquiry View Model                */
    /************************************************/
    function InquiryViewModel() {

        // Self-Identification
        var self = this;

        this.CaptchaAnswer = ko.validatedObservable();

        this.PersonFirstName = ko.validatedObservable();
        this.PersonMiddleName = ko.validatedObservable();
        this.PersonLastName = ko.validatedObservable();
        this.PersonHomePhoneNumber = ko.validatedObservable();
        this.PersonEmailAddress = ko.validatedObservable();
        this.ConfirmPersonEmailAddress = ko.validatedObservable();

        this.WarningMessages = ko.observableArray();

        this.PersonDisplayName = ko.observable();
        this.AccountRequirement = ko.observable();
        this.CaptchaQuestion = ko.observable();
        this.CaptchaAnswerVerification = ko.observable();
        this.PasswordChangeRedirectID = ko.observable();
        this.PersonPreferredContact = ko.observable();
        this.PersonID = ko.observable();
        this.PersonGID = ko.observable();
        this.ApplicationID = ko.observable();
        this.ApplicationGID = ko.observable();

        this.LinkToApplication = ko.observable();
        this.LinkToChangePassword = ko.observable();

        this.TermsAndConditions = ko.observable();
        this.TermsAndConditionsLoaded = ko.observable(false);

        // Model Data
        this.AccountViewModel = ko.observable(new sm.portal.vm.AccountViewModel());
        this.AddressViewModel = ko.observable(new sm.portal.vm.MailingAddressViewModel());
        this.AcademicDetails = ko.observable(
            new sm.portal.vm.AcademicDetailsViewModel()
        );

        // List Data Collections
        this.PreferredContactTypes = ko.observable([new smapi.access.ListItemModel()]);

        this.Loading = ko.observable(false);
        this.TemplatesLoaded = ko.observable(false);
        this.TemplateName = ko.observable("FullInquiryTemplate");

        // Subscriptions
        this.PersonPreferredContact.subscribe(function (newValue) {

            switch (newValue) {
                case "CommunicationType.EmailCommunication":
                    viewModel.ShowAddress(false);
                    viewModel.ShowPhone(false);
                    this.AddressViewModel().SelectedCountryID('');
                    break;
                case "CommunicationType.PhoneCommunication":
                    viewModel.ShowAddress(false);
                    viewModel.ShowPhone(true);
                    this.AddressViewModel().SelectedCountryID('');
                    break;
                case "CommunicationType.MailCommunication":
                    viewModel.ShowAddress(true);
                    viewModel.ShowPhone(false);
                    var systemCountryID = this.AddressViewModel().SystemCountry().ID();
                    if (systemCountryID > 0) {
                        this.AddressViewModel().SelectedCountryID(systemCountryID);
                        this.AddressViewModel().SelectedTemplateID(this.AddressViewModel().AvailableTemplates()[0].ID());
                    }
                    break;
            }

        }, this);
        this.AcademicDetails().AdmissionsProgramIDOne.subscribe(function (newValue) {
            if (!sm.portal.utility.isNullOrEmpty(newValue)) {
                jQuery("div.programOption").removeClass('error');
                jQuery('label[for="AdmissionsProgramIDMessage"]').hide();
            }
        }, this);
        this.AcademicDetails().AdmissionsProgramIDTwo.subscribe(function (newValue) {
            if (!sm.portal.utility.isNullOrEmpty(newValue)) {
                jQuery("div.programOption").removeClass('error');
                jQuery('label[for="AdmissionsProgramIDMessage"]').hide();
            }
        }, this);
        this.AcademicDetails().AdmissionsProgramIDThree.subscribe(function (newValue) {
            if (!sm.portal.utility.isNullOrEmpty(newValue)) {
                jQuery("div.programOption").removeClass('error');
                jQuery('label[for="AdmissionsProgramIDMessage"]').hide();
            }
        }, this);
        this.AcademicDetails().AcademicLevelID.subscribe(function (newValue) {
            if (this.Loading() || !this.AcademicDetails().LevelOfStudyEnabled()) {
                return;
            }
        }, this);

        // Handlers
        this.ForceNoModified = function() {
            this.CaptchaAnswer.isModified(false);

            this.PersonFirstName.isModified(false);
            this.PersonMiddleName.isModified(false);
            this.PersonLastName.isModified(false);
            this.PersonHomePhoneNumber.isModified(false);
            this.PersonEmailAddress.isModified(false);
            this.ConfirmPersonEmailAddress.isModified(false);

            this.AcademicDetails().ForceNoModified();
        };

        this.SetupEntityProperties = function(entity) {

            this.PersonFirstName(entity.PersonFirstName);
            this.PersonMiddleName(entity.PersonMiddleName);
            this.PersonLastName(entity.PersonLastName);
            this.PersonHomePhoneNumber(entity.PersonHomePhoneNumber);
            this.PersonEmailAddress(entity.PersonEmailAddress);
        }

        this.LoadModel = function (container) {
            this.Loading(true);

            // Set the main Entity
            var entity = container.Payload.Entity;
            var options = container.Payload.AvailableOptions;

            this.IsLevelOfStudyActivated = container.Payload.IsLevelOfStudyActivated;
            this.SetupEntityProperties(entity);

            this.AccountRequirement(container.Payload.AccountRequirement);
            this.CaptchaQuestion(container.Payload.CaptchaQuestion);
            this.CaptchaAnswerVerification(container.Payload.CaptchaAnswer);
            this.LinkToApplication(container.Payload.PortalApplicationURL);
            this.LinkToChangePassword(container.Payload.PortalForgotInfoURL);
            this.PasswordChangeRedirectID(container.Payload.PortalForgotInfoRedirectID);
            self.AcademicDetails().LevelOfStudyEnabled(self.IsLevelOfStudyActivated && options.LevelsOfStudy.length > 0);
            this.AcademicDetails().ExpectedEntrancePeriodRequired(container.Payload.IsExpectedEntrancePeriodRequired);

            // Set the list data
            ko.mapping.fromJS(container.Payload.ListData.CommunicationType, {}, this.PreferredContactTypes);

            this.AcademicDetails().SetAvailableOptions(
                options, entity
            );

            this.AddressViewModel().LoadModel(container);
            if (container.Payload.MainAddress != undefined && container.Payload.MainAddress != null && container.Payload.MainAddress.ID != 0) {
                this.AddressViewModel().LoadAddressModel(container.Payload.MainAddress);

                // Set the Selected Country and Selected Template values
                this.AddressViewModel().SelectedCountryID(container.Payload.MainAddress.CountryID);
                this.AddressViewModel().SelectedTemplateID(container.Payload.MainAddress.MailingAddressTemplateID);
            }
            else {

                var systemCountryID = this.AddressViewModel().SystemCountry().ID();
                if (systemCountryID > 0) {
                    this.AddressViewModel().SelectedCountryID(systemCountryID);
                    this.AddressViewModel().SelectedTemplateID(this.AddressViewModel().AvailableTemplates()[0].ID());
                }
            }

            // Take care of the case of validation showing on load
            this.ForceNoModified();

            // Load the Account Model if necessary
            this.AccountViewModel().LoadModel(entity);

            // Modify the Account Model Requirement
            this.AccountViewModel().IsRequired(this.AccountRequirement() == 'required');

            if (container.Payload.TermsConditions) {
                var termsModel = new sm.portal.vm.TermsConditionsViewModel("AfterTerms", container.Payload.TermsConditions, null);
                termsModel.LoadModel(container);

                this.TermsAndConditions(termsModel);
                this.TermsAndConditionsLoaded(true);
            }

            // Set the loading flag
            this.Loading(false);
        };


        this.UpdateOptions = function (data, event) {
            //call api for new options
            if (event.originalEvent)
            {
                if (!this.Loading())
                {
                    // self.BlockContainer();
                    jQuery.blockUI();
                    this.Loading(true);

                    var url = _baseApiUri + sm.portal.utility.formatString('api/PortalInquiry/GetAdmissionsOfferingMatrix');
                    var optionsSelected = JSON.stringify(
                        {
                            CampusID: sm.portal.utility.isNullOrEmpty(this.AcademicDetails().CampusID()) ? null : this.AcademicDetails().CampusID(),
                            AcademicLevelID: sm.portal.utility.isNullOrEmpty(this.AcademicDetails().AcademicLevelID()) ? null : this.AcademicDetails().AcademicLevelID(),
                            LevelOfStudyID: sm.portal.utility.isNullOrEmpty(this.AcademicDetails().LevelOfStudyID()) ? null : this.AcademicDetails().LevelOfStudyID(),
                            DeliveryMethodID: sm.portal.utility.isNullOrEmpty(this.AcademicDetails().DeliveryMethodID()) ? null : this.AcademicDetails().DeliveryMethodID(),
                            AdmissionsProgramIDs: this.AcademicDetails().SelectedAdmissionPrograms(),
                            StartPeriodID: sm.portal.utility.isNullOrEmpty(this.AcademicDetails().ExpectedStartPeriodID()) ? null : this.AcademicDetails().ExpectedStartPeriodID()
                        });

                    sm.portal.utility.AjaxPost(
                        url,
                        optionsSelected,
                        onSuccess = function(data, textStatus, jqXHR) {
                            self.SetAvaliableOptions(data, event.target.id);

                            self.Loading(false);
                            jQuery.unblockUI();
                        },
                        OnError = function(jqXHR, exception) {
                            viewModel.HandleError(exception);
                            self.Loading(false);
                            jQuery.unblockUI();
                        },
                        complete = function (jqXhr, textStatus) {
                            event.target.focus();
                        }
                    );

                }
            }
        };

        this.SetAvaliableOptions = function (options, id) {
            self.AcademicDetails().LevelOfStudyEnabled(self.IsLevelOfStudyActivated && options.LevelsOfStudy.length > 0);

            self.AcademicDetails().AcademicLevels(smapi.access.loadListItemModels(options.AcademicLevels, [], true));
            self.AcademicDetails().AdmissionsProgramsOne(smapi.access.loadListItemModels(options.AdmissionsPrograms.filter(function (x) { return x.Value !== self.AcademicDetails().AdmissionsProgramIDTwo() && x.Value !== self.AcademicDetails().AdmissionsProgramIDThree(); }), [], true));
            self.AcademicDetails().AdmissionsProgramsTwo(smapi.access.loadListItemModels(options.AdmissionsPrograms.filter(function (x) { return x.Value !== self.AcademicDetails().AdmissionsProgramIDOne() && x.Value !== self.AcademicDetails().AdmissionsProgramIDThree(); }), [], true));
            self.AcademicDetails().AdmissionsProgramsThree(smapi.access.loadListItemModels(options.AdmissionsPrograms.filter(function (x) { return x.Value !== self.AcademicDetails().AdmissionsProgramIDOne() && x.Value !== self.AcademicDetails().AdmissionsProgramIDTwo(); }), [], true));
            self.AcademicDetails().DeliveryMethods(smapi.access.loadListItemModels(options.DeliveryMethods, [], true));
            self.AcademicDetails().Campuses(smapi.access.loadListItemModels(options.Campuses, [], true));
            self.AcademicDetails().AcademicPeriods(smapi.access.loadListItemModels(options.ExpectedStartPeriods, [], true));
            self.AcademicDetails().LevelsOfStudy(smapi.access.loadListItemModels(options.LevelsOfStudy.sort(function (l, r) { return l.Sequence - r.Sequence; }), []));

            if (id === 'AcademicLevelID') {
                if (!!self.AcademicDetails().LevelOfStudyID() && !!options.LevelsOfStudy.find(function (element) { return element.ID == self.AcademicDetails().LevelOfStudyID(); })) {
                    return;
                }

                var defaultLevelOfStudy = self.AcademicDetails().LevelOfStudyEnabled() && self.AcademicDetails().AcademicLevelID()
                    ? options.LevelsOfStudy.find(function (element) { return element.IsDefault; })
                    : undefined;
                self.AcademicDetails().LevelOfStudyID(!!defaultLevelOfStudy ? defaultLevelOfStudy.ID : undefined);
            }
        };

        this.PageReady = function () {
            // Submit Handler
            jQuery("#SubmitInquiry").click(function () {
                jQuery.blockUI();
                jQuery("#SubmitInquiry").attr("disabled", "disabled").val(sm.portal.utility.getResourceValue('Submitting'));

                viewModel.SubmitInquiry(_baseApiUri, function (container) {
                    jQuery("#SubmitInquiry").removeAttr('disabled').val('Submit');
                    //jQuery.unblockUI();
                });
            });

            // Ready Page
            sm.portal.ui.readyPage();
        };
        this.LoadInitialData = function () {
            jQuery.blockUI();
            var url = _baseApiUri + 'api/portalinquiry/get';
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    viewModel.LoadModel(container);
                    viewModel.PageReady();
                    jQuery.unblockUI();
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    jQuery.unblockUI();
                }
            });
        };
        this.HandleError = function (title, messages) {
            this.IsError(true);
            if (messages) {
                this.ErrorMessages(messages);
            }
            if (sm.portal.utility.isNullOrEmpty(title)) {
                viewModel.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            } else {
                viewModel.ErrorHeader(title);
            }
        };
        this.PreferredContactTypeRequired = function (type) {
            var required = false;
            switch (type) {
                //case 'EMAIL':
                //    if (this.PersonPreferredContact() === 'CommunicationType.EmailCommunication') {
                //        required = true;
                //    }
                //    break;
                case 'MAIL':
                    if (this.PersonPreferredContact() === 'CommunicationType.MailCommunication') {
                        required = true;
                    }
                    break;
                case 'PHONE':
                    if (this.PersonPreferredContact() === 'CommunicationType.PhoneCommunication') {
                        required = true;
                    }
                    break;
            }
            return required;
        };

        this.ResultMessage = ko.computed(function() {
            // Branch the message based on Membership requirements.
            if (this.AccountRequirement() == "none" || (this.AccountRequirement() == "optional" && sm.portal.utility.isNullOrEmpty(this.AccountViewModel().NewAccountPassword()))) {

                return sm.portal.utility.getResourceValue('StartApplicationLogInNewPassword');
            }
            return sm.portal.utility.getResourceValue('StartApplicationPrePopulateData');
        }, this);
        this.FullLinkForSuccess = ko.computed(function () {

            var baseURL = this.LinkToApplication();
            var queryString = "gid=" + this.PersonGID() + "&attemptGID=" + this.ApplicationGID();   // PersonGID - only if it's populated...

            // If the membership requirement is OPTIONAL or NONE, we may need to redirect elsewhere
            if (this.AccountRequirement() == "none" || (this.AccountRequirement() == "optional" && sm.portal.utility.isNullOrEmpty(this.AccountViewModel().NewAccountPassword()))) {
                baseURL = this.LinkToChangePassword();
                queryString += "&option=ma_show_email_password&redirectid=" + this.PasswordChangeRedirectID();
            }

            // If we don't have a URL or a Query String, return
            if (sm.portal.utility.isNullOrEmpty(baseURL) || sm.portal.utility.isNullOrEmpty(queryString)) {
                return "";
            }

            var portalUrl = baseURL;
            if (baseURL.indexOf("?") >= 0) {
                portalUrl += "&";
            } else {
                portalUrl += "?";
            }
            portalUrl += queryString;
            return portalUrl;
        }, this);

        // Selected Options
        this.ShowResults = ko.observable(false);
        this.ShowResultLink = ko.observable(false);
        this.ShowPhone = ko.observable(false);
        this.ShowAddress = ko.observable(false);
        this.ShowPeriodOption = ko.observable(true);
        this.ShowStartDateOption = ko.observable(false);

        // Error Handling
        this.ErrorHeader = ko.observable();
        this.ErrorMessages = ko.observableArray();
        this.IsError = ko.observable();

        // Extraction Method
        this.ExtractATO = function () {

            var submitObject = ko.mapping.toJS(this);
            // Get the Person data in standard model
            var stdPerson = new smapi.community.PersonModel({
                Surname: self.PersonLastName(),
                GivenName: self.PersonFirstName(),
                MiddleName: self.PersonMiddleName(),
                ID: self.PersonID()
            });

            // Get the Email Address object in standard model
            var stdEmail = new smapi.community.ElectronicAddressModel({
                Value: self.PersonEmailAddress()
            });
            stdPerson.ElectronicAddresses.push(stdEmail);

            // Add in the Phone Number object in standard model
            var stdPhone = null;
            if (!sm.portal.utility.isNullOrEmpty(self.PersonHomePhoneNumber())) {
                stdPhone = new smapi.community.PhoneNumberModel({
                    Number: self.PersonHomePhoneNumber()
                });
                stdPerson.PhoneNumbers.push(stdPhone);
            }

            // Add in the Address object in standard model
            var stdAddress = null;

            stdAddress = self.AddressViewModel().ExtractATO();
            stdPerson.Addresses.push(stdAddress);

            // Set the Admissions / Academic details in standard model
            var stdAdmissionsAttempt = new smapi.admissions.AdmissionsAttemptModel({
                PersonID: -1,
                AdmissionsAcademicLevelID: self.AcademicDetails().AcademicLevelID(),
                ExpectedStartPeriodID: self.AcademicDetails().ExpectedStartPeriodID(),
                CampusID: self.AcademicDetails().CampusID(),
                DeliveryMethodID: self.AcademicDetails().DeliveryMethodID(),
                LevelOfStudyID: self.AcademicDetails().LevelOfStudyEnabled() ? self.AcademicDetails().LevelOfStudyID() : null
            });

            stdAdmissionsAttempt.Surname(self.PersonLastName());
            stdAdmissionsAttempt.MiddleName(self.PersonMiddleName());
            stdAdmissionsAttempt.GivenName(self.PersonFirstName());

            // Add in a Program object for each selected.
            if (!sm.portal.utility.isNullOrEmpty(self.AcademicDetails().AdmissionsProgramIDOne())) {
                var stdAdmProgramOne = new smapi.admissions.AdmissionsAttemptProgramModel({
                    AdmissionsAcademicLevelID: self.AcademicDetails().AcademicLevelID(),
                    AdmissionProgramID: self.AcademicDetails().AdmissionsProgramIDOne()

                });
                stdAdmissionsAttempt.AdmissionsAttemptPrograms.push(stdAdmProgramOne);
            }
            if (!sm.portal.utility.isNullOrEmpty(self.AcademicDetails().AdmissionsProgramIDTwo())) {
                var stdAdmProgramTwo = new smapi.admissions.AdmissionsAttemptProgramModel({
                    AdmissionsAcademicLevelID: self.AcademicDetails().AcademicLevelID(),
                    AdmissionProgramID: self.AcademicDetails().AdmissionsProgramIDTwo()

                });
                stdAdmissionsAttempt.AdmissionsAttemptPrograms.push(stdAdmProgramTwo);
            }
            if (!sm.portal.utility.isNullOrEmpty(self.AcademicDetails().AdmissionsProgramIDThree())) {
                var stdAdmProgramThree = new smapi.admissions.AdmissionsAttemptProgramModel({
                    AdmissionsAcademicLevelID: self.AcademicDetails().AcademicLevelID(),
                    AdmissionProgramID: self.AcademicDetails().AdmissionsProgramIDThree()

                });
                stdAdmissionsAttempt.AdmissionsAttemptPrograms.push(stdAdmProgramThree);
            }

            if (!sm.portal.utility.isNullOrEmpty(viewModel.ApplicationID())) {
                stdAdmissionsAttempt.ID = viewModel.ApplicationID();
            }

            var termsAndConditions = null;
            if (!sm.portal.utility.isNullOrEmpty(self.TermsAndConditions())) {
                termsAndConditions = self.TermsAndConditions().ExtractATO();
            }

            var submitModel = {
                ID: self.ApplicationID(),

                // Account Data
                NewAccountPassword: self.AccountViewModel().NewAccountPassword(),
                PersonID: self.PersonID(),
                PersonGID: self.PersonGID(),

                PersonalInformation: ko.toJS(stdPerson),
                AdmissionsInformation: ko.toJS(stdAdmissionsAttempt),
                TermsData: ko.toJS(termsAndConditions)
            };
            return submitModel;
        };

        // Core Method
        this.SubmitInquiry = function (baseUri, successHandler) {

            if (self.IsVMValid()) {
                var url = baseUri + 'api/portalinquiry/SubmitInquiry';
                var data = this.ExtractATO();

                jQuery.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(data),
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {

                        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                        if (data.Status == 'submitted') {
                            // Show the results message, hide the rest
                            viewModel.IsError(false);
                            viewModel.PersonDisplayName(container.Payload.DisplayName);
                            viewModel.PersonGID(container.Payload.PersonGID);
                            viewModel.PersonID(container.Payload.PersonID);
                            viewModel.ApplicationID(container.Payload.ApplicationID);
                            viewModel.ApplicationGID(container.Payload.ApplicationGID);
                            viewModel.ShowResults(true);
                            viewModel.ShowResultLink(true);
                            viewModel.WarningMessages(data.Payload.WarningMessages);
                            jQuery.unblockUI();
                        }
                        else if (data.Status == 'validationerror') {

                            viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                            jQuery.unblockUI();

                        } else if (data.Status == 'error') {

                            viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                            jQuery.unblockUI();
                        }

                        // Call the Success Handler
                        successHandler(container);
                    },
                    error: function (jqXHR, exception) {

                        viewModel.HandleError(exception);
                        jQuery.unblockUI();
                    }
                });
            }
            else {
                jQuery.unblockUI();
            }
        };

        // Validation Methods
        this.PersonFirstName.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PersonMiddleName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PersonLastName.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PersonHomePhoneNumber.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.PreferredContactTypeRequired('PHONE');
                }
            },
            pattern: {
                params: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_ItsNotAValidPhoneNumber),
                onlyIf: function () {
                    return self.PreferredContactTypeRequired('PHONE');
                }
            },
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20'),
                onlyIf: function () {
                    return self.PreferredContactTypeRequired('PHONE');
                }
            },
            minLength: {
                params: 6,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_ItsNotAValidPhoneNumber),
                onlyIf: function () {
                    return self.PreferredContactTypeRequired('PHONE');
                }
            }
        });
        this.PersonEmailAddress.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            email: {
                params: true,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'Example@domain.com')
            },
            validation: {
                onlyIf: function () {
                    return !self.AccountViewModel().IsLoggedIn();
                },
                validator: function (val) {
                    var url = _baseApiUri + 'api/studentportal/DuplicatedEmail?email=' + val;
                    var duplicatedEmail = jQuery.ajax({
                        url: url,
                        type: 'GET',
                        async: false,
                        dataType: 'html',
                        contentType: 'application/json; charset=utf-8',
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (data, textStatus, jqXHR) {
                            return data;
                        }
                    });

                    if (duplicatedEmail.responseText == "true")
                        return false;

                    return true;
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_DuplicateEmail_Key)
            }
        });
        this.ConfirmPersonEmailAddress.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.AccountViewModel().IsRequired() === true && self.AccountViewModel().ShowNewAccount() === true;
                }
            },
            smMatchingValue: {
                params: self.PersonEmailAddress,
                message: sm.portal.utility.getResourceValue('EmailDoesNotMatch'),
                onlyIf: function () {
                    return self.AccountViewModel().IsRequired() === true && self.AccountViewModel().ShowNewAccount() === true;
                }
            }
        });

        this.CaptchaAnswer.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
            },
            smMatchingValue: {
                params: self.CaptchaAnswerVerification,
                message: sm.portal.utility.getResourceValue('AntiSpamAnswerMismatch')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            var o = this.ModelErrors().length == 0 && this.AccountViewModel().IsVMValid();
            if (this.PreferredContactTypeRequired('MAIL'))
                o = o && this.AddressViewModel().IsVMValid();
            return o;

        };
        this.IsInquiryFormValid = ko.computed(function () {
            if(!self.IsVMValid())
                return false;

            if(!self.AcademicDetails().IsVMValid())
                return false;

            if(self.TermsAndConditionsLoaded() && !self.TermsAndConditions().Completed())
                return false;

            return true;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        InquiryViewModel: InquiryViewModel
    });

})(jQuery);
